import { connect } from 'react-redux';
import type { ActionCreator } from 'redux';
import type { OverrideValues, AccommodationState } from '@/interfaces';
import { actions } from '@/state/filterActions';
import { fetchHotels } from '@/ducks/searchResults/actions';
import {
    type SelectedCheckboxDispatchProps,
    SelectedCheckboxFilter,
    type SelectedCheckboxStateProps,
} from '../../../../components/selectedCheckboxFilter/SelectedCheckboxFilter';
import { mapFacilities } from './HotelFacilityFilter';

import displayValues from '@/assets/displayValues.json';

export const mapStateToProps = (state: AccommodationState): SelectedCheckboxStateProps => ({
    id: 'HotelFacilityFilter',
    facetList: mapFacilities(state.searchResults.facilities),
    displayValues: Object.keys(displayValues.features).reduce((result: Record<string, string>, key: string) => {
        result[key] = displayValues.features[key].localisedName ?? displayValues.features[key].name;

        return result;
    }, {}),
    checkboxValues: state.filters.facility,
});

export const mapDispatchToProps: OverrideValues<SelectedCheckboxDispatchProps, ActionCreator<unknown>> = {
    checkBoxClick: actions.filterFacility,
    triggerFetch: fetchHotels,
};

export default connect(mapStateToProps, mapDispatchToProps)(SelectedCheckboxFilter);
